import { render } from "./SolutionDetails.vue?vue&type=template&id=6d5f5f32&scoped=true"
import script from "./SolutionDetails.vue?vue&type=script&lang=js"
export * from "./SolutionDetails.vue?vue&type=script&lang=js"

import "./SolutionDetails.vue?vue&type=style&index=0&id=6d5f5f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5f5f32"]])

export default __exports__